///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, exportDatasActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN_DL_FILE } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const postExportDatas = function* ({ payload }) {
	const url = payload.url
	const bodyMsg = payload.filters
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_EXPORT_DATAS(url)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN_DL_FILE(user.jwt).post(apiCall, bodyMsg)

		yield put(exportDatasActionCreators.postExportDatasSuccess(data.data))

		let filename = data.headers['content-disposition'].split('=')[1]
		let type = data.headers['content-type']
		let url = window.URL.createObjectURL(new Blob([data.data], { type: type }))

		let a = document.createElement('a')
		a.href = url

		a.setAttribute('download', filename)
		document.body.appendChild(a)
		a.click()
		document.body.removeChild(a)
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(exportDatasActionCreators.postExportDatasFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.POST_EXPORT_DATAS, postExportDatas)
}

export default sagas
